<template>
  <q-dialog :visible="visible" title="移至其他清单" width="500px" @close="onCancel" :innerScroll="false" :loading="loading" :showFooter="false">
    <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
      <el-form-item label="已选择商品数">
        {{ selectedCount }}
      </el-form-item>
      <el-form-item label="迁移清单名称" prop="moveListNo" class="required-label">
        <el-select v-model="form.moveListNo" placeholder="请选择" size="mini">
          <el-option v-for="item in listOptions" :key="item.listNo" :label="item.name" :value="item.listNo"> </el-option>
        </el-select>
      </el-form-item>
      <div class="tips">备注:只能选择未发布的上市清单</div>
    </el-form>

    <div class="dialog-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm">迁移</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'RemoveToList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
    listNo: [Number, String],
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      form: {
        moveListNo: '',
      },
      rules: {
        moveListNo: [{ required: true, message: '请选择迁移清单名称', trigger: 'change' }],
      },
      listOptions: [],
    };
  },
  computed: {
    selectedCount() {
      return this.selectedRows.length;
    },
  },
  mounted() {
    this.getOPtions();
  },
  methods: {
    getOPtions() {
      const formData = new FormData();
      formData.append('listNo', this.listNo);
      this.$q.newProduct.queryNoPublishNewProductList({ data: formData }).then((res) => {
        this.listOptions = res.data;
      });
    },
    onCancel() {
      this.$emit('update:visible', false);
    },
    onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loadingBtn = true;
        const data = {
          spuList: this.selectedRows.map(v => ({
            skuCode: v.skuCode,
            spuCode: v.spuCode,
            expecUpDate: v.expecUpDate
          })),
          moveListNo: this.form.moveListNo,
          listNo: this.listNo,
        };
        this.$q.newProduct
          .moveNewProductList({ data: data })
          .then((res) => {
            if (res.success) {
              this.$message.success('迁移成功');
              this.$emit('success');
              this.onCancel();
            } else {
              this.$notify.error({
                message: res.message || '迁移失败',
                duration: 0
              });
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--mini .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 300px !important;

>>> .el-input
    width 300px !important;

.dialog-footer
  text-align: center
  margin-top: 30px
.tips
  color red
  padding-left 20px
</style>
